import React from "react";
import BlogPostLayout, { Section, Figure, Cta } from "./Blogpostlayout.tsx";

const Blogpage4: React.FC = () => {
  return (
    <BlogPostLayout
      title="How Important is Digital Marketing for an IT Business? (Spoiler: Critical)"
      date="August 29, 2025"
      readTime="6 min read"
      heroImg="https://placehold.co/1200x600/1f2937/d1d5db?text=Digital+Marketing+for+IT"
      heroAlt="Digital Marketing for IT"
      tags={["SEO", "Digital Marketing", "Lead Generation"]}
    >
      <Section title="Why IT Firms Can’t Skip Marketing">
        <Figure
          side="right"
          src="https://placehold.co/600x400/1f2937/d1d5db?text=Online+Visibility"
          alt="Online visibility"
          caption="If you are not visible online, potential clients will not find you."
        />
        <p>
          Buyers research online, shortlist silently, and talk to sales late. If you’re invisible online,
          you’re out—no matter how good your delivery is.
        </p>
      </Section>

      <Section title="Build the Funnel (Step-by-Step)">
        <h3 style={{ marginTop: 0 }}>TOFU (Awareness)</h3>
        <ul>
          <li><strong>Topics:</strong> “Cloud costs demystified,” “Zero-trust quick start,” “Build vs. buy.”</li>
          <li><strong>Channels:</strong> SEO blog, LinkedIn posts, webinars, developer tutorials.</li>
        </ul>

        <h3>MOFU (Consideration)</h3>
        <ul>
          <li>
            <strong>Assets:</strong> Comparison guides, ROI calculators, architecture checklists, case studies.
          </li>
        </ul>

        <h3>BOFU (Decision)</h3>
        <ul>
          <li><strong>Offers:</strong> Free assessments, PoC credits, migration plans, reference calls.</li>
        </ul>
      </Section>

      <Section title="Channel Mix That Works">
        <Figure
          side="left"
          src="https://placehold.co/600x400/1f2937/d1d5db?text=Channel+Mix"
          alt="Channel Mix"
          caption="A mix of channels is essential for reaching your target audience."
        />
        <ul>
          <li><strong>SEO:</strong> 10–20 pillar pages + clusters (services, industries, tech stacks).</li>
          <li>
            <strong>LinkedIn ABM:</strong> Target ICP by industry/title; value-first messages; retarget site
            visitors.
          </li>
          <li>
            <strong>PPC (Google/Bing):</strong> Capture high-intent keywords (“managed IT services,” “cloud
            migration partner”).
          </li>
          <li><strong>Email Automation:</strong> Nurture sequences by interest (cloud, data, security).</li>
          <li><strong>Webinars/Workshops:</strong> “Cost-down in 30 days,” “SRE basics for CIOs.”</li>
        </ul>
      </Section>

      <Section title="Website & CRO Essentials">
        <ul>
          <li>Clear USP above the fold, proof (logos, testimonials), 1 primary CTA.</li>
          <li>Offer short forms (name, email, company) + calendar embed.</li>
          <li>Add conversion assets: templates, calculators, checklists.</li>
        </ul>
      </Section>

      <Section title="Measurement (Don’t Skip)">
        <ul>
          <li><strong>North stars:</strong> Pipeline influenced, SQOs, CAC payback.</li>
          <li>
            <strong>Leading indicators:</strong> demo requests, MQL→SQL rate, CTR, CPL, bounce rate, time on
            page.
          </li>
        </ul>
      </Section>

      <Section title="90-Day Plan">
        <ul>
          <li><strong>Month 1:</strong> ICP/keywords, site CRO fixes, 6 core pages refreshed.</li>
          <li><strong>Month 2:</strong> Launch PPC/LinkedIn ABM, publish 4 blogs + 1 case study.</li>
          <li>
            <strong>Month 3:</strong> Run a webinar, start email nurture, review CPL/CAC—double-down on
            winners.
          </li>
        </ul>
      </Section>

      <Cta
        title="Want our IT marketing keyword list and funnel templates?"
        text="Grab the free pack."
        label="Grab the Free Pack"
      />
    </BlogPostLayout>
  );
};

export default Blogpage4;